import _ from 'lodash';
import { useCallback, useContext, useEffect, useState } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { useNavigate, Link } from 'react-router-dom';
import UserContext from '../../../../contexts/UserContext';
import { resetPassword } from '../../../../services/users';

type ForgotPasswordFormInput = { email: string };

function ForgotPasswordForm({ onResetPasswordSuccess }: { onResetPasswordSuccess: () => void }) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<ForgotPasswordFormInput>();

  const handleLogin: SubmitHandler<ForgotPasswordFormInput> = useCallback(
    async (data) => {
      setLoading(true);
      if (data.email) {
        try {
          const reset = await resetPassword(data.email);
          setLoading(false);
          if (reset) navigate('/auth/reset-password', { state: { email: data.email } });
          else alert('Something went wrong');
        } catch (error) {
          setLoading(false);
          if (_.has(error, 'code')) {
            switch (_.get(error, 'code')) {
              case 'NotAuthorizedException':
                alert('Invalid email or password');
                break;

              case 'UserNotFoundException':
                alert('An account with this email address does not exist');
                break;
            }
          }
        }
      }
    },
    [navigate]
  );

  return (
    <form action="#" className="w-full" onSubmit={handleSubmit(handleLogin)}>
      <div className="mt-4 w-full">
        <label htmlFor="username">
          Email
          <input data-test="username-input" id="username" type="text" placeholder="e.g. you@gmail.com" {...register('email', { required: true })} />
          {errors['email'] && <span className="text-sm text-ginger font-raleway-italic">Email is required</span>}
        </label>
      </div>
      <div className="mt-5 w-full">
        {!loading && (
          <button data-test="login-btn" className="block text-center bg-periwinkle text-white p-3 rounded-full text-lg w-full">
            Reset
          </button>
        )}

        {loading && <span>Loading</span>}
      </div>
      <div className="mt-10">
        <Link to="/auth/login">Cancel</Link>
      </div>
    </form>
  );
}

const ForgotPassword = () => {
  const { currentUser } = useContext(UserContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (currentUser && currentUser?.username !== null) navigate('/home');
  }, [currentUser, navigate]);
  return (
    <div className="flex overflow-hidden">
      <div id="main-content" className="h-full w-full xs:px-5 pt-20">
        <main>
          <div className="py-10 lg:w-2/3 xl:w-1/3 mx-auto">
            <div className="bg-white rounded-xl py-10 px-10 xl:px-20 flex flex-col items-center justify-center shadow-sm">
              <div className="flex mb-4">
                <h1 className="text-lg xs:text-4xl font-analogue">Forgot password?</h1>
              </div>
              <ForgotPasswordForm onResetPasswordSuccess={() => navigate('/home')} />
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default ForgotPassword;
